/**
 * @param {string} phone
 * @returns {Boolean}
 */
 export function validPhone(phone) {
  const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
  return reg.test(phone)
}

/**
 * @param {string} chinese
 * @returns {Boolean}
 */
//  中文校验
export function validChinese(chinese) {
//  const reg = /^[\u0391-\uFFE5A-Za-z]+$/
  const reg = /[\u4E00-\u9FA5\uF900-\uFA2D]/;
  return reg.test(chinese)
}

// 数字+字母校验
export function validStrAndNum(str) {
  const reg = /^[\a-\z\A-\Z0-9]+$/;
  return reg.test(str)
}

/**
 * @param {string} cardNo
 * @returns {Boolean}
 */
//  身份证号码
export function validCardNo(cardNo) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  return reg.test(cardNo)
}



// WEBPACK FOOTER //
// ./src/utils/validate.js